import { getRefreshToken } from './getToken';

// Simple role switching utility
export const switchToProvider = (facilityId?: string) => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    console.error('No refresh token found');
    return false;
  }

  // Get provider domain from environment or use default
  const providerDomain = process.env.REACT_APP_PROVIDER_DOMAIN || 'https://jamborecords-devapp.scouting.org/' || 'http://localhost:3001/';
  
  // Build URL with refresh token and facility ID
  const url = `${providerDomain}dashboard?refreshToken=${encodeURIComponent(refreshToken)}&facilityId=${encodeURIComponent(facilityId || '')}`;
  
  // Redirect to provider domain
  window.location.href = url;
  return true;
};

export const switchToAdmin = (facilityId?: string) => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    console.error('No refresh token found');
    return false;
  }

  // Get admin domain from environment or use default
  const adminDomain = process.env.REACT_APP_ADMIN_DOMAIN || 'https://jamborecords-devapp.scouting.org/' || 'http://localhost:3000/';
  
  // Build URL with refresh token (no facility ID for admin)
  const url = `${adminDomain}dashboard?refreshToken=${encodeURIComponent(refreshToken)}&facilityId=${encodeURIComponent(facilityId || '')}`;
  
  // Redirect to admin domain
  window.location.href = url;
  return true;
};
